// Dehumidifier Device Type Templates

import { Template02_Modern } from './Template02_Modern';

export { Template01_Full } from './Template01_Full';
export { Template02_Modern } from './Template02_Modern';

// Template registry for dynamic selection
export const DehumidifierTemplates = {
  Template01: () => import('./Template01_Full').then(m => m.Template01_Full),
  Template02: () => import('./Template02_Modern').then(m => m.Template02_Modern),
} as const;

// Default export - using Template02 (Modern) as the new default
export default Template02_Modern;
